module.exports = __webpack_public_path__ + "img/ic_instagram_default.a1337088.svg";